import { render, staticRenderFns } from "./fybxmx.vue?vue&type=template&id=4e94c016&scoped=true"
import script from "./fybxmx.vue?vue&type=script&lang=js"
export * from "./fybxmx.vue?vue&type=script&lang=js"
import style0 from "./fybxmx.vue?vue&type=style&index=0&id=4e94c016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e94c016",
  null
  
)

export default component.exports